import { Box, List, CircularProgress } from '@mui/material';
import { AddressSearchHelper } from './AddressSearchHelper.component';
import { AddressSearchListItem } from './AddressSearchListItem.component';
import { AddressSearchListNoRows } from './AddressSearchNoRows.component';

export type AddressSearchListRowType = {
  id: string;
  address: string;
  addressCityState: string;
};

export type AddressSearchListType = {
  rows: AddressSearchListRowType[];
  loading: boolean;
  onAddressSelect: (id: string) => void;
  onManualSelect: () => void;
  showResults: boolean;
  searchValue: string;
};

export const AddressSearchList: React.VFC<AddressSearchListType> = ({
  rows = [],
  onAddressSelect,
  onManualSelect,
  loading,
  showResults,
  searchValue
}) => {

  if (showResults && !rows.length && !loading) {
    return (
      <Box mt={3.75}>
        <AddressSearchListNoRows onManualSelect={onManualSelect} />
      </Box>
    );
  }

  return (
    <Box mt={1}>
      {showResults && loading && !rows.length && (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      )}
      {showResults && (
        <List disablePadding>
          {rows.map((row, i) => {
            return (
              <AddressSearchListItem
                key={i}
                row={row}
                searchValue={searchValue}
                onAddressSelect={onAddressSelect}
              />
            );
          })}
        </List>
      )}
      {(!loading || !!rows.length) && (
        <AddressSearchHelper
          showResults={showResults}
          onManualSelect={onManualSelect}
        />
      )}
    </Box>
  );
};
